var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.252,
    y: 0.166,
    fill: "none",
    width: 39.33,
    height: 47.834
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 4.252,
    y: 0.166,
    width: 48,
    height: 47.834
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#E73537",
    points: "42.751,30.751 37.928,25.93 32.389,31.471 26.85,25.93  22.023,30.751 27.563,36.294 22.023,41.834 26.85,46.658 32.389,41.119 37.928,46.658 42.751,41.834 37.212,36.294  "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 4.75,
    width: 48,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    d: "M43.205,0.013L19.961,2.958c-0.27,0.029-0.48,0.246-0.521,0.53 c-0.039,0.278,0.1,0.549,0.346,0.659c1.479,0.688,2.699,1.653,3.771,2.746C9.68,15.412,2.388,31.783,5.436,48l6.258-1.296 c-2.52-13.394,3.54-26.946,15.056-34.029c0.318,1.413,0.441,2.871,0.223,4.368c-0.041,0.271,0.096,0.533,0.32,0.658 c0.088,0.042,0.174,0.066,0.27,0.066c0.154,0,0.308-0.066,0.426-0.191L43.701,1.08c0.184-0.188,0.225-0.481,0.117-0.717 C43.701,0.121,43.479-0.05,43.205,0.013"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUp);
export default __webpack_public_path__ + "static/media/noUp.19b83b4d38c518a96fbd33a0f9a5aea1.svg";
export { ForwardRef as ReactComponent };